export const ArtworkImage = ({ artwork, sizes, priority = false, className, testId, descriptionId }) => (
  <img
    src={artwork.src}
    srcSet={artwork.srcSet}
    sizes={sizes}
    width={artwork.width}
    height={artwork.height}
    alt={artwork.alt}
    aria-describedby={descriptionId}
    loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"}
    decoding="async"
    className={className}
    data-testid={testId}
  />
);